module.exports = __webpack_public_path__ + "img/vertical_4_6_3.2948c542.png";